/* jshint browserify: true */

require('./modules/tinymce');
require('./modules/popin');
require('./media/video');
require('./media/video/thumbnail');
require('./widgets/foldable');
require('./widgets/calendarSelect');
require('./smiley');
require('../trapFocus');
